module.exports = __webpack_public_path__ + "img/nz.d0503f76.svg";